import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { c2cApi } from "../../api/c2c-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function ChangeLanguage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="min-h-screen bg-neutral-900 w-full revert-style">
      <AcendexLayout
        pcTopBarTitle={translate(getText("語言選擇"))}
        mobileTopBarTitle={translate(getText("語言選擇"))}
        hideBottomBar
        theme="light"
      >
      <div className="container mx-auto">
        <CenterPage />
      </div>
      </AcendexLayout>
    </div>
  );
}
